import {StateProvider} from "@uirouter/angularjs";
import {UserConfigProvider} from "../types/UserConfig";
import {CompanyInfoView} from "./view/CompanyInformationViewComponent";

/** @ngInject */
export default function($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    if (userConfigProvider.config.features.SCREEN_COMPANY_INFO) {
        $stateProvider.state("company-info", {
            url: "/company-info?view&security",
            component: CompanyInfoView,
            data: {
                pageTitle: "Company Information"
            },
            params: {
                security: {
                    dynamic: true,
                    type: "string"
                },
                view: {
                    dynamic: true,
                    type: "string"
                }
            }
        });
    }
}
